const nodes = [
  { label: "LiDAR / camera / ultrasonic", x: 24, width: 190 },
  { label: "Raspberry Pi perception + navigation", x: 260, width: 220 },
  { label: "Movement commands", x: 526, width: 172 },
  { label: "Arduino motor control", x: 744, width: 180 },
];

export function SystemDiagram() {
  return (
    <div className="system-diagram" role="img" aria-label="Sensors feed Raspberry Pi perception and navigation, which generates commands for Arduino motor control and the motors; robot movement creates a feedback loop">
      <svg viewBox="0 0 960 330" aria-hidden="true">
        <defs>
          <marker id="diagram-arrow" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <path d="M0 0 8 4 0 8Z" className="diagram-arrow-fill" />
          </marker>
          <pattern id="diagram-dots" width="16" height="16" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" className="diagram-dot" />
          </pattern>
        </defs>
        <rect width="960" height="330" rx="20" fill="url(#diagram-dots)" />
        {nodes.map((node, index) => (
          <g key={node.label}>
            <rect className="diagram-node" x={node.x} y="92" width={node.width} height="80" rx="10" />
            <text className="diagram-node-index" x={node.x + 14} y="116">0{index + 1}</text>
            <foreignObject x={node.x + 14} y="126" width={node.width - 28} height="38">
              <div className="diagram-node-label">{node.label}</div>
            </foreignObject>
            {index < nodes.length - 1 && (
              <path className="diagram-connector" d={`M${node.x + node.width + 8} 132H${nodes[index + 1].x - 10}`} markerEnd="url(#diagram-arrow)" />
            )}
          </g>
        ))}
        <g>
          <rect className="diagram-node diagram-node-accent" x="612" y="230" width="244" height="64" rx="10" />
          <text className="diagram-node-index" x="626" y="253">05</text>
          <foreignObject x="626" y="259" width="214" height="30"><div className="diagram-node-label">Drivers → motors → movement</div></foreignObject>
          <path className="diagram-connector" d="M834 177v44" markerEnd="url(#diagram-arrow)" />
          <path className="diagram-feedback" d="M603 263H112c-42 0-63-28-63-72" markerEnd="url(#diagram-arrow)" />
          <text className="diagram-feedback-label" x="308" y="252">movement + environment feedback</text>
        </g>
      </svg>
    </div>
  );
}
